import script from "./NewsPageObjectList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageObjectList.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageObjectList.vue?vue&type=style&index=0&id=5bd8b829&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd8b829"]])

export default __exports__